import { fetchGet } from "../generalFetch";
import { fetchUrl } from "@/constants/fetchUrl";

export default {
  async read(payload) {
    const url = fetchUrl["sales_manuals"];
    return await fetchGet(url, payload, "sales_manuals");
  },
};
